import React, { Component } from "react";
import { Button, Modal, Row, Col } from "reactstrap";
import { Formik } from "formik";
import * as Yup from "yup";
import { connect } from "react-redux";
import moment from "moment";
import { Card } from "@material-ui/core";
import TruckTypeSelect from "../../BasicComponents/truckTypeSelect";
import ChargesStartEndDate from "../../BasicComponents/ChargesStartEndDate";
import {
  NonVehiclePlacementChargesHeaders,
  searchBar,
} from "./DataTableHeaders";
import { getLocalStorage } from "../../RowHeaders/RowHeaders";
import Index from "../../../../components/Common/DataTableNeo/Index";
// var data = {};
let userLang = JSON.parse(window.localStorage.getItem("userLangDetail"));

class CancellationUponArrivalCompany extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      vehicleObject: [],
      vehicleTypeLabel: "",
      vehicleType: "",
      charges: "",
      startDate: "",
      endDate: "",
      cancellationUponArrivalCompanyForm: [],
      cancellationUponArrivalCompanyFormID: [],
      viewMode: false,
      DateAltered: false,
      fetchId: "",
      agreementId: "",
    };
  }

  dateResetterOnModalClose = () => {
    this.setState({ startDate: "", endDate: "" });
  };

  componentDidUpdate = () => {
    let arr = [];
    let arrID = [];
    let vehicleObj = [];
    if (
      (this.props.billing.copiedAgreementValues.id &&
        !this.state.cancellationUponArrivalCompanyForm.length &&
        !this.state.viewMode) ||
      (this.state.fetchId !== this.props.billing.fetchId &&
        this.state.agreementId !== this.props.billing.copiedAgreementValues.id)
    ) {
      this.props.billing.copiedAgreementValues.charges.cancellationUponArrivalByCompany.forEach(
        (item, index) => {
          // console.log(item, index);
          arr.push({
            vehicleType: item.vehicleType.label,
            charges: item.charges,
            startDate: moment(item.startDate).format("l"),
            endDate: moment(item.endDate).format("l"),
          });
          arrID.push({
            vehicleType: item.vehicleType._id,
            charges: item.charges,
            startDate: item.startDate,
            endDate: item.endDate,
          });
          vehicleObj.push({
            label: item.vehicleType.label,
            value: item.vehicleType._id,
          });
        }
      );
      this.setState(
        {
          cancellationUponArrivalCompanyForm: arr,
          cancellationUponArrivalCompanyFormID: arrID,
          vehicleObject: vehicleObj,
          viewMode: true,
          agreementId: this.props.billing.copiedAgreementValues.id,
          fetchId: this.props.billing.fetchId,
        },
        () => {
          this.props.listFiller(
            this.state.cancellationUponArrivalCompanyForm,
            this.state.cancellationUponArrivalCompanyFormID
          );
          this.props.listShow();
        }
      );
    } else if (
      this.props.billing.startDate &&
      this.props.billing.endDate &&
      !this.state.DateAltered
    ) {
      // console.log("STATE LOGS", this.state);
      let arr = this.state.cancellationUponArrivalCompanyForm;
      let arrID = this.state.cancellationUponArrivalCompanyFormID;
      arr.forEach((item, index) => {
        item.startDate = this.props.billing.startDate.Date;
        item.endDate = this.props.billing.endDate.Date;
        // console.log("ITEM: ", index, "-", item);
      });
      arrID.forEach((item, index) => {
        item.startDate = this.props.billing.startDate.Date;
        item.endDate = this.props.billing.endDate.Date;
        // console.log("ITEMID: ", index, "-", item);
      });
      this.setState(
        {
          cancellationUponArrivalCompanyForm: arr,
          cancellationUponArrivalCompanyFormID: arrID,
          DateAltered: true,
        },
        () => {
          // console.log("ARR", this.state.cancellationUponArrivalCompanyForm);
          this.props.listFiller(
            this.state.cancellationUponArrivalCompanyForm,
            this.state.cancellationUponArrivalCompanyFormID
          );
          this.props.listShow();
        }
      );
    }
  };

  handleDelete = (item) => {
    let modifiedArray = [];
    let modifiedIDArray = [];
    let id;
    // console.log("dlete");
    modifiedArray = this.state.cancellationUponArrivalCompanyForm.filter(
      (e) => e.vehicleType !== item.vehicleType
    );
    this.state.vehicleObject.find((o, i) => {
      if (o.label === item.vehicleType) {
        id = this.state.vehicleObject[i].value;
      }
      return null;
    });
    modifiedIDArray = this.state.cancellationUponArrivalCompanyFormID.filter(
      (e) => e.vehicleType !== id
    );
    this.setState(
      {
        cancellationUponArrivalCompanyForm: modifiedArray,
        cancellationUponArrivalCompanyFormID: modifiedIDArray,
      },
      () => {
        this.props.listFiller(
          this.state.cancellationUponArrivalCompanyForm,
          this.state.cancellationUponArrivalCompanyFormID
        );
      }
    );
    // console.log("-----", this.state.cancellationUponArrivalCompanyForm);
    // console.log(this.state.cancellationUponArrivalCompanyFormID, "--------");
  };

  render() {
    userLang = JSON.parse(window.localStorage.getItem("userLangDetail"));
    const validationSchema = Yup.object({
      vehicleType: Yup.object().required(
        userLang?.planning?.VEHICLE_TYPE_IS_REQUIRED
      ),
      startdate: Yup.date().required(userLang?.invoice?.DATE_IS_REQUIRED),
      expirydate: Yup.date().required(userLang?.invoice?.DATE_IS_REQUIRED),
      charges: Yup.number().required(userLang?.invoice?.CHARGES_IS_REQUIRED),
    });

    this.state.cancellationUponArrivalCompanyForm.forEach((item) => {
      item.actions = (
        <div style={{ color: "red" }}>
          <i
            className="fas fa-trash-alt darkInvoiceModalIcons"
            style={{ cursor: "pointer" }}
            onClick={() => this.handleDelete(item)}
          ></i>
        </div>
      );
    });
    // data = {
    //   columns: NonVehiclePlacementChargesHeaders,
    //   rows: this.state.cancellationUponArrivalCompanyForm,
    // };

    return (
      <React.Fragment>
        {getLocalStorage()}
        <Modal
          isOpen={this.props.modal}
          toggle={this.props.toggle}
          size="xl"
          className="ModalHeight"
        >
          <Row className="mt-2">
            <Col xs={8}>
              <div className="m-3">
                <h4
                  className="fontRoboto light__span"
                  style={{
                    whiteSpace: "nowrap",
                  }}
                >
                  {userLang?.invoice?.CANCELLATION_UPON_ARRIVAL_ADD_COMPANY}{" "}
                </h4>
              </div>
            </Col>
            <Col xs={4} className="text-right">
              <i
                className="fas fa-times closemodal1  pr-2 text-right close"
                onClick={() => this.props.toggle()}
              ></i>
            </Col>
          </Row>
          <Row className="m-2">
            <Formik
              initialValues={{
                vehicleType: this.state.vehicleTypeLabel,
                charges: this.state.charges,
                startdate: this.props.startDate,
                expirydate: this.props.endDate,
              }}
              validationSchema={validationSchema}
              validateOnChange={true}
              onSubmit={(values, { resetForm }, e) => {
                let chargeArray = [];
                let chargeArrayID = [];
                // console.log("valu9399", values);
                this.setState(
                  {
                    vehicleObject: this.state.vehicleObject.concat(
                      values.vehicleType
                    ),
                    vehicleTypeLabel: values.vehicleType.label,
                    vehicleType: values.vehicleType.value,
                    charges: values.charges,
                    startDate: values.startdate,
                    endDate: values.expirydate,
                  },
                  () => {
                    // console.log("------", this.state);
                    chargeArray = {
                      vehicleType: this.state.vehicleTypeLabel,
                      charges: this.state.charges,
                      startDate: this.state.startDate,
                      endDate: this.state.endDate,
                    };
                    chargeArrayID = {
                      vehicleType: this.state.vehicleType,
                      charges: this.state.charges,
                      startDate: this.state.startDate,
                      endDate: this.state.endDate,
                    };
                    this.setState(
                      {
                        vehicleTypeLabel: "",
                        vehicleType: "",
                        charges: "",
                      },
                      () => {
                        // console.log(chargeArray);
                        this.setState(
                          {
                            cancellationUponArrivalCompanyForm:
                              this.state.cancellationUponArrivalCompanyForm.concat(
                                chargeArray
                              ),
                            cancellationUponArrivalCompanyFormID:
                              this.state.cancellationUponArrivalCompanyFormID.concat(
                                chargeArrayID
                              ),
                          },
                          () => {
                            // console.log(
                            //   this.state.cancellationUponArrivalCompanyForm
                            // );
                            // console.log(this.state);
                            this.props.listFiller(
                              this.state.cancellationUponArrivalCompanyForm,
                              this.state.cancellationUponArrivalCompanyFormID
                            );
                          }
                        );
                      }
                    );
                  }
                );
                resetForm({
                  values: {
                    vehicleType: "",
                    charges: "",
                    startdate: this.state.startDate,
                    expirydate: this.state.endDate,
                  },
                });
              }}
            >
              {(formik) => {
                const {
                  setFieldValue,
                  handleChange,
                  handleSubmit,
                  values,
                  errors,
                  touched,
                  handleBlur,
                } = formik;
                return (
                  <Col xs={12}>
                    <form onSubmit={handleSubmit}>
                      <Row>
                        <Col xs={12} md={3}>
                          <TruckTypeSelect
                            handleBlur={handleBlur}
                            errors={errors}
                            touched={touched}
                            val={values.vehicleType}
                            setFieldValue={setFieldValue}
                          />
                        </Col>
                        <Col xs={12} md={7}>
                          <ChargesStartEndDate
                            valid={this.props.valid}
                            validExpiry={this.props.validExpiry}
                            handleBlur={handleBlur}
                            errors={errors}
                            touched={touched}
                            chargeVal={values.charges}
                            startDateVal={values.startdate}
                            endDateVal={values.expirydate}
                            handleChange={handleChange}
                            setFieldValue={setFieldValue}
                          />
                        </Col>
                        <Col xs={6} md={1} lg={1}>
                          <Button
                            style={{
                              width: "100%",
                              position: "relative",
                              top: "37%",
                              backgroundColor: "#05284E",
                            }}
                            type="submit"
                            color="secondary"
                            className={`small align-middle rounded rounded-black mb-1 ${
                              this.props.mode ? "darkAgreementAddToList" : ""
                            }`}
                          >
                            <span style={{ fontWeight: "900" }}>
                              {userLang?.invoice?.ADD_To_LIST}
                            </span>
                          </Button>{" "}
                        </Col>
                        <Col xs={6} md={1} lg={1}>
                          <Button
                            style={{
                              width: "100%",
                              position: "relative",
                              top: "37%",
                              backgroundColor: "#0AB38C",
                            }}
                            type="button"
                            color="primary"
                            className="small align-middle rounded mb-1"
                            onClick={() => {
                              this.props.listShow();
                              this.props.toggle();
                              this.dateResetterOnModalClose();
                            }}
                            disabled={!this.state.cancellationUponArrivalCompanyForm?.length}
                          >
                            <span style={{ fontWeight: "900" }}>
                              {" "}
                              {userLang?.invoice?.SAVE_ALL}
                            </span>
                          </Button>{" "}
                        </Col>
                      </Row>
                    </form>
                  </Col>
                );
              }}
            </Formik>
            <Col xs={12} className="DataTable darkDataTableCharges">
              <Card>
                <Index
                  headers={NonVehiclePlacementChargesHeaders}
                  data={this.state.cancellationUponArrivalCompanyForm}
                  searchBar={searchBar}
                  rowHeight={"56px"}
                  limit ={this.state.cancellationUponArrivalCompanyForm.length}
                />
              </Card>
            </Col>
          </Row>
        </Modal>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  billing: state.SecondaryBilling.SecondaryBilling,
});

export default connect(mapStateToProps, {})(CancellationUponArrivalCompany);
